import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/public/places/[id]/enquiry-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/marketplace-view-beacon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/menu-order.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/whatsapp-enquiry.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
